export const NavbarLogo = () => (
  <div className="navbar-logo">
    <a href="/">
      <img src="/static/images/white-logo.svg" alt="Marshall Reddick Real Estate" />
    </a>
  </div>
);
